export default __webpack_public_path__ + "static/media/higher_icon_calendar_reversed.895a2e6b.svg";